import { LOGIN_SUCCESS } from '../store/home/HomeConstants'

export const LOGOUT = 'auth/LOGOUT'
export const REFRESH_TOKEN_SUCCESS = 'auth/REFRESH_TOKEN_SUCCESS'
export const INTERNAL_SERVER_ERROR = 'auth/INTERNAL_SERVER_ERROR'
export const NETWORK_ERROR = 'auth/NETWORK_ERROR'
export const CLEAR_INTERNAL_SERVER_ERROR = 'auth/CLEAR_INTERNAL_SERVER_ERROR'
export const CLEAR_500_ERROR = 'auth/CLEAR_500_ERROR'

const SET_CONNECTION = 'auth/SET_CONNECTION'
const initialState = {
  accessToken: '',
  isInternalError: false,
  isNetworkError: false,
  loggedIn: false,
  isConnected: true,
  serverErrorMessage: '',
}
// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export function setConnection(value) {
  return {
    type: SET_CONNECTION,
    payload: value,
  }
}
/**
 * `reason` is read by `logoutTeardownMiddleware` to decide how far the teardown goes —
 * an untagged logout gets the full purge-and-reload. See QMD-4332.
 */
export function logout(reason?: string) {
  return {
    type: LOGOUT,
    reason,
    payload: {},
  }
}
export function clearInternalError() {
  return {
    type: CLEAR_INTERNAL_SERVER_ERROR,
  }
}
export function clear500Error() {
  return {
    type: CLEAR_500_ERROR,
  }
}

export default function authReducer(state = initialState, action = {}) {
  // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
  switch (action.type) {
    case SET_CONNECTION:
      return {
        ...state,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        isConnected: action.payload,
      }
    case LOGIN_SUCCESS:
    case REFRESH_TOKEN_SUCCESS:
      return {
        ...state,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        accessToken: action.payload.AccessToken,
        loggedIn: true,
      }
    case INTERNAL_SERVER_ERROR:
      return {
        ...state,
        isInternalError: true,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        serverErrorMessage: action.payload,
      }
    case NETWORK_ERROR:
      return {
        ...state,
        isNetworkError: true,
      }
    case CLEAR_INTERNAL_SERVER_ERROR:
      return {
        ...state,
        isInternalError: false,
        serverErrorMessage: '',
      }
    case CLEAR_500_ERROR:
      return {
        ...state,
        isNetworkError: false,
      }
    case LOGOUT: {
      return {
        ...initialState,
      }
    }
    default:
      return state
  }
}
